import { styled } from "@mui/material/styles";
import Typography from "@bmi-digital/components/typography";
import RecaptchaPrivacyLinks from "../RecaptchaPrivacyLinks";

export const StyledProductOverview = styled("div")({
  padding: "36px 0"
});

export const StyledRecaptchaPrivacyLinks = styled(RecaptchaPrivacyLinks)(
  ({ theme }) => ({
    paddingTop: "18px",
    [theme.breakpoints.up("lg")]: {
      paddingTop: "24px"
    }
  })
);

export const StyledEmpcoFootnote = styled(Typography)(({ theme }) => ({
  paddingTop: "18px",
  wordBreak: "break-word",
  [theme.breakpoints.up("lg")]: {
    paddingTop: "24px"
  }
}));
